export default __webpack_public_path__ + "static/media/noexpl_13_EN.c75eec5f.png";